import InvestmentDepositFormNew from './InvestmentDepositFormNew';

export default InvestmentDepositFormNew;
